import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { CompanyService } from "../../../_services/company.service";
import { ContactService } from "../../../_services/contact.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";

@Component({
  selector: "app-new-company",
  templateUrl: "./new-company.component.html",
  styleUrls: ["./new-company.component.css"],
})
export class NewCompanyComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_company = false;

  constructor(private service: CompanyService) {}

  new_company = new FormGroup({
    email: new FormControl(),
    name: new FormControl("", [Validators.required]),
    phone: new FormControl(),
    is_client: new FormControl(),
    is_seller: new FormControl(),
    speaks_french: new FormControl(),
  });

  ngOnInit() {}

  openModal(value) {
    if (value) this.new_company.patchValue({ name: value });
    jQuery("#add-company-modal")
      .modal({ inverted: true, allowMultiple: true })
      .modal("show");
  }

  // New Contact
  submitContactForm() {
    this.new_company.disable(); // Disable the form to avoid changes during the Creation process
    this.creating_company = true; // Trigger the Loading button apparition
    jQuery("#add-company-modal").modal({ closable: false }); // Set the modal unclosable during the creation process
    this.service
      .createCompany(this.new_company.value) // Create the Contact
      .subscribe((response) => {
        jQuery("#add-company-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.creating_company = false; // Disable the loading button apparition
        this.new_company.enable(); // Re Enable the Form
        this.new_company.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company/new-company/new-company.component.ts